import React from 'react';
import { useAuth } from '../../auth/AuthContext';
import { useLocation } from 'react-router-dom';
import AccessDeniedPage from '../common/AccessDeniedPage';

const UserRoute = ({ children }) => {
  const { userType } = useAuth();
  const location = useLocation();
  const isUser = !userType || userType !== 'G';

  return isUser ? (
    children
  ) : (
    <AccessDeniedPage redirectPath={location.pathname} />
  );
};

export default UserRoute;
